import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { motion } from 'framer-motion';

import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { Confetti } from '@/components/Animations/Confetti/Confetti';
import { Picture } from '@/components/ui/Picture/Picture';

import styles from './styles.module.scss';

import lightPng from '/img/patterns/light.png';
import lightWebp from '/img/patterns/light.webp';

interface ClaimRewardOverlayProps {
  onClose: () => void;
  webp: string;
  png: string;
  amount: number;
  type: 'cash' | 'tgem';
}

const ClaimRewardOverlay: FC<ClaimRewardOverlayProps> = ({
  onClose,
  amount,
  png,
  type,
  webp,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="bg-black/60 fixed inset-0 flex flex-col items-center justify-center z-[9999]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <Confetti
        className="inset-0 absolute"
        loop={false}
        onComplete={onClose}
        speed={1.5}
      />
      <Picture
        alt="light"
        webp={lightWebp}
        img={lightPng}
        className="absolute w-full h-max [&>img]:h-auto mix-blend-overlay -z-10"
      />
      <Picture webp={webp} img={png} alt="reward" className="size-32 -mt-2" />
      <span className={styles.rewardGradientText}>
        +{toShortNumFormat(amount)}
      </span>

      <span className={cn(styles.rewardGradientText, 'mt-2 text-[1.5rem]')}>
        {type === 'tgem' ? t('Tgem') : t('Cash')}
      </span>
    </motion.div>
  );
};

export default ClaimRewardOverlay;
